import './style.css';
import { Icon } from '@chatui/core';
import { useState } from 'react';
import { ResponseFeedbackType } from '../../../utils/types';

interface ResponseFeedbackProps {
  sendFeedback: (feedbackValue: string) => void;
}

const ResponseFeedback = (props: ResponseFeedbackProps) => {
  const [feedback, setFeedback] = useState<ResponseFeedbackType | null>(null);
  const { sendFeedback } = props;

  const onFeedbackClick = (feedbackValue: number) => {
    setFeedback(feedbackValue as ResponseFeedbackType);
    sendFeedback(feedbackValue.toString());
  };

  return (
    <div className="response-feedback">
      <Icon
        type="thumbs-down"
        onClick={() => {
          if (feedback === null) {
            onFeedbackClick(0);
          }
        }}
        className={`feedback-button${
          feedback === 0 ? ' active' : feedback === 1 ? ' inactive' : ''
        }`}
      />
      <Icon
        type="thumbs-up"
        onClick={() => {
          if (feedback === null) {
            onFeedbackClick(1);
          }
        }}
        className={`feedback-button${
          feedback === 1 ? ' active' : feedback === 0 ? ' inactive' : ''
        }`}
      />
    </div>
  );
};

export default ResponseFeedback;
